import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleCountryTuitionFee extends TitleBase {
	private countryValue: string;
	private tuitionFeeValue: string;

	protected canHandle(): boolean {
		this.countryValue = this.getFilterValue(ParameterType.COUNTRY);
		this.tuitionFeeValue = this.getFilterValue(ParameterType.TUITION_FEE);

		return (
			this.indexableFilters.length === 2 &&
			this.indexableFilters.some((_) => _.type === ParameterType.COUNTRY) &&
			this.indexableFilters.some((_) => _.type === ParameterType.TUITION_FEE)
		);
	}

	protected getPageTitle(): string {
		return `${this.tuitionFeeValue} ${this.titlePortalType} in ${this.countryValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(`${this.tuitionFeeValue.toLowerCase()} ${this.titlePortalType}`, ` in ${this.countryValue}`);
	}
}
